import React from "react";

function Hours() {
  return (
    <div className="hours">
      <h2>Hours of Operation</h2>
      <p>Mon - Sat: 9:30am - 6pm</p>
      <p>Sunday: 9am - 3pm</p>
    </div>
  );
}

export default Hours;
